module.exports = __webpack_public_path__ + "assets/img/line_type.8b3be8a5.png";